import UltraRewardPage from "./UltraRewardPage";

export default UltraRewardPage;
